/* eslint-disable */
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export type UploadImagesResponse = {
  success: boolean;
  message: string;
  data: {
    ids: string[];
  };
};

const uploadImages = async (files: File[]): Promise<UploadImagesResponse> => {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));

  const { data } = await customAxios.post<UploadImagesResponse>(
    "/upload/multiple",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );

  return data;
};

export const useUploadImages = () =>
  useMutation<UploadImagesResponse, AxiosError, File[]>({
    mutationFn: uploadImages,

    onError: (error) =>
      showNotification({
        title: "Upload Failed",
        message:
          (error.response?.data as { message?: string })?.message ??
          "Failed to upload images",
        color: "red",
      }),
  });
